<template>

    <CascoAjanlatBase :titleExtra="titleExtra"  v-if="elozmenyIgazolasVisible() || allianzKarVisible() || allianzPartnerVisible()">

        <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatok">

            <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="elozm_ig_datum" />

            <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="elozm_torl_datum" />

            <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="elozm_bonusz_jogkezd_datum" />

            <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="ajanl_rendszam" />

            <BnFormField v-if="allianzPartnerVisible()" :attributes="allianz_casco_partner_szerzszam"/>

            <template v-if="allianzKarVisible()">

                <BnFormField :key="index" v-for="(ev, index) in getKarEv()"
                             :attributes="{
                            label: 'Kgfb károk azonos járműkategóriában ' + ev + ' -ben/ban',
                            type: 'select',
                            visible: true,
                            editable: true,
                            help: index === 0,
                            rules: [v => v >= 0 || 'Károk azonos járműkategóriában' + ev +
                            '-ben/ban'],
                            options: [
                                {key: 0, value: 'Nem okoztam kárt' },
                                {key: 1, value: '1 kárt okoztam' },
                                {key: 2, value: '2 kárt okoztam' },
                                {key: 3, value: '3 kárt okoztam' },
                                {key: 4, value: '4 vagy több kárt okoztam'},
                            ],
                            itemsText: 'value',
                            itemsValue: 'key',
                            mezo: 'tf_' + ev + '_kardb',
                            path: 'tarifaData.evenkenti_karok.tf_' + ev + '_kardb'
                        }"
               />

            </template>

        </v-form>

    </CascoAjanlatBase>

</template>
<script>
import { rules } from '../../../../../../../../modules/Validators';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';

export default {
    components: { CascoAjanlatBase, BnFormField },
    mixins: [cascoOfferData],
    methods: {
        elozmenyIgazolasVisible() {
            return this.$store.getters.vanCascoBonusz;
        },
        allianzPartnerVisible() {
            return this.kedvezmenyek.partnerlakas === true || this.kedvezmenyek.partnerelet === true
                || this.kedvezmenyek.partnergfb === true;
        },
        allianzKarVisible() {
            return this.$store.getters.tarifaData.karok.tf_kar_ebben_utoljara_ev > 1
                && parseInt(this.$store.getters.tarifaData.ajanl_kock_kezd, 10) < 20220101;
        },
        getKarEv() {
            const arr = [];
            for (let i = Number(this.$store.getters.tarifaData.karok.tf_kar_ebben_utoljara_ev); i >= 2017; i -= 1) {
                arr.push(i);
            }
            return arr;
        },
    },
    data() {
        return {
            name: 'AjanlatAdatokB1_V0',
            version: 'v0',
            elozm_ig_datum: {
                type: 'date',
                label: 'CASCO előzmény igazolásának dátuma',
                visible: true,
                editable: true,
                rules: [(v) => rules.required(v, 'CASCO előzmény igazolásának dátumának megadása kötelező!')],
                mezo: 'elozm_ig_datum',
                path: 'tarifaData.elozm_ig_datum',
                help: true,
            },
            elozm_torl_datum: {
                type: 'date',
                label: 'CASCO előzményszerződés megszűnésének dátuma',
                visible: true,
                editable: true,
                rules: [(v) => rules.required(v, 'CASCO előzményszerződés megszűnésének dátuma megadása kötelező!')],
                mezo: 'elozm_torl_datum',
                path: 'tarifaData.elozm_torl_datum',
                help: true,
            },
            elozm_bonusz_jogkezd_datum: {
                type: 'date',
                label: 'CASCO kármentesség kezdete',
                visible: true,
                editable: true,
                rules: [(v) => rules.required(v, 'CASCO kármentesség kezdetének megadása kötelező!')],
                mezo: 'elozm_bonusz_jogkezd_datum',
                path: 'tarifaData.elozm_bonusz_jogkezd_datum',
                help: true,
            },
            allianz_casco_partner_szerzszam: {
                type: 'text',
                label: 'Az partner kedvezmény alapjául szolgáló biztosítás kötvényszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'allianz_casco_partner_szerzszam',
                path: 'tarifaData.allianz_casco_partner_szerzszam',
                mask: '!V',
            },

            ajanl_rendszam: {
                type: 'text',
                label: 'CASCO előzményszerződéshez tartózó gépjármű rendszáma',
                visible: true,
                editable: true,
                mask: 'GGGGGGGGG',
                mezo: 'ajanl_rendszam',
                path: 'tarifaData.ajanl_rendszam',
                help: true,
            },
            elozoelozorendszam: {
                type: 'text',
                label: 'CASCO előzményszerződés kötvényszáma',
                visible: true,
                editable: true,
                rules: [(v) => rules.required(v, 'CASCO előzményszerződés kötvényszámának megadása kötelező!')],
                mezo: 'elozoelozorendszam',
                path: 'tarifaData.elozoelozorendszam',
                help: true,
            },
        };
    },
};
</script>
